<template>
<div>
  <v-progress-linear v-show="load" :indeterminate="true" />

  <v-main class="py-2 px-2">
    <!-- *************DADOS GERAIS DA UNIDADE********************** -->
    <!-- ***************************TABELAS************************ -->
    <v-layout row>
      <v-flex xs12 sm12 class="pr-1">
        <v-card outlined class="rounded-xl">
          <v-card-title>
            Média total dos atendimentos:
          </v-card-title>

          <v-card-text class=" pt-0">
            <span class="display-1 font-weight-light">{{ mediaAtendimentos }}</span> (min)
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12>
        <v-card  outlined class="ma-1 rounded-xl">
          <v-card-title class="font-weight-bold">
            Tempo de atendimento
            <v-spacer />
            <v-text-field v-model="search1" append-icon="search" label="Buscar" single-line hide-details />
          </v-card-title>

          <v-data-table :headers="headers1" :items="listaTabela1" items-per-page-text="Linhas por página" no-data-text="Nenhum item disponível para o intervalo buscado" :loading="loadingTabela1" :search="search1">
            <template v-slot:items="props">
              <td>{{ props.item.nome }}</td>
              <td class="text-xs-center">
                {{ props.item.quantAtendimentos }}
              </td>
              <td class="text-xs-center">
                {{ props.item.mediaAtendimento }}
              </td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua busca por "{{ search1 }}" não encontrou
                resultados.
              </v-alert>
            </template>
          </v-data-table>

        </v-card>
      </v-flex>
    </v-layout>
  </v-main>
</div>
</template>

<script>

import administradorUnidadeService from './../../../services/administradorUnidade.service'

export default {
  name: 'FuncionariosOnline',
  components: {

  },

  props: {
    atendimentoRecep: Object
  },

  data: (vm) => ({
    valid: true,
    quantAtendimentos: 0,
    mediaAtendimentoUnidade: 0,
    mediaAtendimentos: '',
    tempoEspera: 0,
    loadingTabela1: false,
    loadingTabela2: false,
    load: 0,
    date1: '',
    date2: '',
    menu1: false,
    menu2: false,
    search1: '',
    search2: '',
    listaFuncionariosTabela: [],
    headers1: [{
      text: 'Recepcionista',
      align: 'center',
      value: 'nome'
    },
    {
      text: 'Quantidade de Atendimentos',
      align: 'center',
      value: 'quantAtendimentos'
    },
    {
      text: 'Média de Atendimento',
      align: 'center',
      value: 'mediaAtendimento'
    }
    ],
    headers2: [{
      text: 'Mes',
      align: 'center',
      value: 'mes',
      sortable: true
    },
    {
      text: 'Data',
      align: 'center',
      value: 'data'
    },
    {
      text: 'Tempo de espera',
      align: 'center',
      value: 'tempoEspera'
    },
    {
      text: 'Quantidade de atendimentos',
      align: 'center',
      value: 'quantAtendimentos'
    }
    ],
    listaTabela1: [{
      nome: '---',
      quantAtendimentos: '---',
      mediaAtendimento: '---'
    },
    {
      nome: '---',
      quantAtendimentos: '---',
      mediaAtendimento: '---'
    }
    ],
    listaTabela2: [{
      mes: '---',
      data: '---',
      quantAtendimentos: '---',
      tempoEspera: '---'
    },
    {
      mes: '---',
      data: '---',
      quantAtendimentos: '---',
      tempoEspera: '---'
    }
    ]
  }),
  computed: {

  },

  mounted () {
    if (this.atendimentoRecep) {
      this.carregarDadosTabelas()
    }
  },

  created () {
    console.log('created...')
  },

  methods: {

    formatarTempo (tempo) {
      var a = tempo.split(':')
      var text = ''
      if (a[0] != '00') {
        text = a[0] + ' hr' + text
      }
      if (a[1] != '00') {
        text = a[1] + ' min' + text
      }
      if (a[2] != '00') {
        text = a[2] + ' sg' + text
      }
      return text
    },

    carregarDadosTabelas (date1, date2) {
      console.log('Carregar dados Unidade')
      this.tempoAtendimentoRecep(date1, date2) // tabela
    },

    calculaMediaAtendimentoUnidade (lista) {
      if (!lista.length) {
        return 0
      }
      var produto = 0
      var somaAtendimentos = 0
      lista.forEach((element) => {
        somaAtendimentos = somaAtendimentos + element.quantAtendimentos
        var hms = element.mediaAtendimento // your input string
        var a = hms.split(':') // split it at the colons
        var seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2]
        var newSeconds = element.quantAtendimentos * seconds
        produto = produto + newSeconds
      })
      var result = produto / somaAtendimentos
      var date = new Date(result * 1000)
      var hh = date.getUTCHours()
      var mm = date.getUTCMinutes()
      var ss = date.getSeconds()
      // If you were building a timestamp instead of a duration, you would uncomment the following line to get 12-hour (not 24) time
      // if (hh > 12) {hh = hh % 12;}
      // These lines ensure you have two-digits
      if (hh < 10) {
        hh = '0' + hh
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      if (ss < 10) {
        ss = '0' + ss
      }
      // This formats your string to HH:MM:SS
      var t = hh + ':' + mm + ':' + ss
      return t
    },

    tempoAtendimentoRecep () {
      this.listaTabela1 = this.atendimentoRecep.lista
      this.mediaAtendimentos = this.atendimentoRecep.mediaTotalAtendimentos
    },
    tempoEsperaPacienteRecep () {
      // essa n precisa de tabela
      this.load = this.load + 1

      administradorUnidadeService.administradorUnidade
        .tempoEsperaPacienteRecep(this.date1, this.date2)
        .then((rsp) => {
          console.log('rsp tempoEsperaPacienteRecep:', rsp.data)
          if (rsp.data.length) {
            this.quantAtendimentos = rsp.data[0].quantAtendimentos
            this.tempoEspera = rsp.data[0].tempoEspera
          }
        })
        .finally(() => {
          this.load = this.load - 1
        })
        .catch((err) => {
          // handle your error here
          console.log(err)
        })
    },
    tempoEsperaPacienteRecep_ () {
      // essa n precisa de tabela
      this.load = this.load + 1

      administradorUnidadeService.administradorUnidade
        .tempoEsperaPacienteRecep(this.date1, this.date2)
        .then((rsp) => {
          console.log('rsp tempoEsperaPacienteRecep:', rsp.data)
          if (rsp.data.length) {
            this.quantAtendimentos = rsp.data[0].quantAtendimentos
            this.tempoEspera = rsp.data[0].tempoEspera
          }
        })
        .finally(() => {
          this.load = this.load - 1
        })
        .catch((err) => {
          // handle your error here
          console.log(err)
        })
    },
    tempoEsperaDiaRecep () {
      this.load = this.load + 1
      administradorUnidadeService.administradorUnidade
        .tempoEsperaDiaRecep(this.date1, this.date2)
        .then((rsp) => {
          console.log('rsp tempoEsperaDiaRecep:', rsp.data)
          rsp.data.forEach((element) => {
            var data = new Date(element.data)
            element.mes = data.getMonth() + 1
          })
          this.listaTabela2 = rsp.data
          this.loadingTabela2 = false
        })
        .finally(() => {
          this.load = this.load - 1
        })
        .catch((err) => {
          // handle your error here
          this.loadingTabela2 = false
          console.log(err)
        })
    },

    converterDate (data) {
      if (data == '---') {
        return '---'
      } else {
        var d = new Date(data)
        var dia = d.getDate().toString()
        var diaF = dia.length == 1 ? '0' + dia : dia
        var mes = (d.getMonth() + 1).toString() // +1 pois no getMonth Janeiro começa com zero.
        var mesF = mes.length == 1 ? '0' + mes : mes
        var anoF = d.getFullYear()

        return diaF + '/' + mesF + '/' + anoF
      }
    }
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}

.input-qty {
  width: 60px;
  height: 25px;
  border: 2px solid #80cbc4;
  border-radius: 5px;
}

.rounded-card {
  border-radius: 35px;
}
</style>
